import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "質問管理")
], -1)
const _hoisted_3 = { class: "d-grid d-md-flex justify-content-md-end" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("カテゴリ登録")
const _hoisted_5 = { class: "table table-hover table-bordered" }
const _hoisted_6 = {
  key: 0,
  scope: "col",
  style: {"width":"30px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"min-width":"60px"}
}, "カテゴリ名", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"min-width":"60px"}
}, "説明文", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"width":"60px"}
}, "編集", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "質問・手続き", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "プレビュー", -1)
const _hoisted_12 = {
  key: 0,
  class: "drag"
}
const _hoisted_13 = { class: "ms-1" }
const _hoisted_14 = { class: "d-flex justify-content-center" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("セクション一覧")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("インポート")
const _hoisted_17 = ["disabled", "onClick"]
const _hoisted_18 = ["disabled", "onClick"]
const _hoisted_19 = {
  key: 0,
  class: "d-grid d-md-flex justify-content-md-start"
}
const _hoisted_20 = { class: "d-grid d-md-flex justify-content-md-center" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("戻る")

import { ref, unref } from 'vue'
import { useMessenger } from '@/plugins/message'
import { useStore } from '@/store'
import IconUpDownLeftRight from '@/components/ui/IconUpDownLeftRight.vue'
import IconEyeSlash from '@/components/ui/IconEyeSlash.vue'
import IconPenToSquare from '@/components/ui/IconPenToSquare.vue'
import draggable from 'vuedraggable'
import { useNicotto, ConciergeCategory } from '@/plugins/nicotto'
import { onBeforeRouteLeave } from "vue-router";
import ButtonLink from "@/components/ui/ButtonLink.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexView',
  setup(__props) {

const isDraggable = ref(false)
const nicotto = useNicotto()
const messenger = useMessenger()
const store = useStore()
const categories = ref<ConciergeCategory[]>([])
const initial = ref<ConciergeCategory[]>([])
nicotto.concierge.getCategoryList()
  .then(data => {
    categories.value = data
    initial.value = unref(categories)
  })

const save = async() => {
  try {
    const result = await nicotto.concierge.updateSortCategoryList(categories.value)
    if (result != null) {
      messenger.set('concierge.drag.saveSucceeded')
      isDraggable.value = false
      initial.value = categories.value
    } else {
      messenger.set('concierge.drag.saveFailed')
    }
  } catch (err) {
    console.log(err)
    messenger.set('concierge.drag.saveFailed')
  }
}

const cancel = () => {
  isDraggable.value = false
  categories.value = initial.value
}

const exportExcel = async(category: ConciergeCategory) => {
  store.commit("startLoading")
  const linkUrl = window.URL.createObjectURL(await nicotto.concierge.getCategoryExcel(category.categoryId))
  const link = document.createElement('a')
  link.href = linkUrl
  link.download = `${category.name}.xlsx`
  link.click()
  window.URL.revokeObjectURL(linkUrl)
  store.commit("finishLoading")
}

onBeforeRouteLeave(() => {
  messenger.hide()
})

const preview = async(category: ConciergeCategory) => {
  // プレビューデータ生成
  try {
    store.commit("startLoading")
    await nicotto.concierge.publishConcierge('preview', category.categoryId)
  } catch (err:any) {
    for (let i = 0; i < err.errors.length; i++) {
      if (err.errors[i].message.indexOf('process not found.') !== -1 ) {
        messenger.set('concierge.preview.publishFailedByProcess')
      } else if (err.errors[i].message.indexOf('contact not found.') !== -1 ) {
        messenger.set('concierge.preview.publishFailedByContact')
      } else {
        messenger.set('concierge.preview.publishFailed')
      }
      store.commit("finishLoading")
      return
    }
    store.commit("finishLoading")
    return
  }

  // プレビューURL発行
  const municipality = store.getters.isAdmin
    ? store.state.municipality
    : store.state.user?.municipality
  try {
    const url = await nicotto.concierge.getPreviewUrl(municipality?.path as string, category)
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.rel = 'noopener noreferrer'
    link.click()
    store.commit("finishLoading")
  } catch (err) {
    messenger.set('concierge.preview.generateUrlFailed')
    store.commit("finishLoading")
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ButtonLink, {
        class: "btn-primary mx-2 mb-2",
        to: "/concierge/categories/new",
        disabled: isDraggable.value
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("table", _hoisted_5, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (isDraggable.value)
            ? (_openBlock(), _createElementBlock("th", _hoisted_6))
            : _createCommentVNode("", true),
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _hoisted_11
        ])
      ]),
      _createVNode(_unref(draggable), {
        modelValue: categories.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((categories).value = $event)),
        "item-key": "id",
        tag: "tbody",
        handle: ".drag"
      }, {
        item: _withCtx(({ element }) => [
          _createElementVNode("tr", null, [
            (isDraggable.value)
              ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                  _createVNode(IconUpDownLeftRight)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("td", null, [
              _createTextVNode(_toDisplayString(element.name), 1),
              _createElementVNode("span", _hoisted_13, [
                (element.publishMode=='private')
                  ? (_openBlock(), _createBlock(IconEyeSlash, { key: 0 }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("td", null, _toDisplayString(element.description), 1),
            _createElementVNode("td", null, [
              _createVNode(ButtonLink, {
                class: "btn-primary",
                to: `/concierge/categories/${element.categoryId}`,
                disabled: isDraggable.value,
                title: "編集"
              }, {
                default: _withCtx(() => [
                  _createVNode(IconPenToSquare)
                ]),
                _: 2
              }, 1032, ["to", "disabled"])
            ]),
            _createElementVNode("td", _hoisted_14, [
              _createVNode(ButtonLink, {
                class: "btn-success",
                to: `/concierge/categories/${element.categoryId}/sections`,
                disabled: isDraggable.value
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 2
              }, 1032, ["to", "disabled"]),
              _createVNode(ButtonLink, {
                class: "btn-outline-secondary mx-2",
                to: `/concierge/categories/${element.categoryId}/import`,
                disabled: isDraggable.value
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 2
              }, 1032, ["to", "disabled"]),
              _createElementVNode("button", {
                class: "btn btn-outline-secondary me-2",
                type: "button",
                disabled: isDraggable.value,
                onClick: ($event: any) => (exportExcel(element))
              }, "エクスポート", 8, _hoisted_17)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                class: "btn btn-outline-secondary",
                type: "button",
                disabled: isDraggable.value,
                onClick: ($event: any) => (preview(element))
              }, "プレビュー", 8, _hoisted_18)
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    (categories.value.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary mx-2 mb-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (isDraggable.value ? cancel() : isDraggable.value = true))
          }, _toDisplayString(isDraggable.value ? "キャンセル" : "並び替え"), 1),
          (isDraggable.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary mx-2 mb-2",
                onClick: save
              }, "確定"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(ButtonLink, {
        class: "btn-secondary mx-2 mb-2",
        to: "/",
        disabled: isDraggable.value
      }, {
        default: _withCtx(() => [
          _hoisted_21
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})